export default "__VITE_ASSET__BsW5jizg__"